import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=98435ea8&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=ts"
export * from "./NotificationList.vue?vue&type=script&lang=ts"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=98435ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98435ea8",
  null
  
)

export default component.exports